export default __webpack_public_path__ + "static/2-acebe3046fcd2ae45ca332a97263b321.png";